import { render, staticRenderFns } from "./daily-expense.vue?vue&type=template&id=84d334a0"
import script from "./daily-expense.vue?vue&type=script&lang=js"
export * from "./daily-expense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports